import {useCallback, useState} from "react";
import {platformAPI} from "../../../api/axiosConfig";
import {ImportContact} from "./useMapImportRows";

type SubmitImportPayload = {
    name: string;
    clientID: string;
    flags: {
        matchOnEmail: boolean;
        archiveMissing: boolean;
    };
    contacts: ImportContact[];
};

export function useSubmitImport() {
    const [submitting, setSubmitting] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const submit = useCallback(async (payload: SubmitImportPayload): Promise<string | null> => {
        setSubmitting(true);
        setError(null);
        try {
            const res = await platformAPI.post<{importID: string}>("api/contacts/import", payload);
            return res.data.importID;
        } catch (e: any) {
            setError(e?.response?.data?.error ?? "error submitting import");
            return null;
        } finally {
            setSubmitting(false);
        }
    }, []);

    return {submit, submitting, error};
}
